import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { useEffect, useState } from "react";

const Review = () => {
  const reviewList = [
    {
      src: "/images/review1.png",
      txt: `도어락을 사긴했는데 설치를 못해서<br/>
키플레이어에 요청드렸더니<br/>
30분도 안걸려서 해주시고 가셨어요`,
    },
    {
      src: "/images/review2.png",
      txt: `도어락이 이상한 소리를 내면서<br/>
눌러도 불만들어오고 눌리질 않아<br/>
요청드려 해결했습니다.`,
    },
    {
      src: "/images/review3.png",
      txt: `도어락 교체는 처음해보는데<br/>
여자 혼자사는 집 도어락에 맞게<br/>
추천도 해주시고 친절하셨어요`,
    },
    {
      src: "/images/review4.png",
      txt: `새벽에 갑자기 고장나 손쓸방법이<br/>
없었는데 다행히 키플레이어가<br/>
24시간이라 해결했습니다.`,
    },
    {
      src: "/images/review5.png",
      txt: `어머님 혼자 살고계신 집이라 불안해<br/>
도어락설치를 이번에 진행했는데<br/>
정말 순식간에 해주시더라구요`,
    },
    {
      src: "/images/review6.png",
      txt: `저녁 퇴근시간임에도 정말 빨리<br/>
출동해주시고 도어락 교체도<br/>
15분도 안걸려서 해주셨답니다`,
    },
    {
      src: "/images/review7.png",
      txt: `새벽시간대라 참 막막했는데<br/>
키플레이어 덕분에 밖에서 외박안하고<br/>
집으로 들어올 수 있었네요.. 감사합니다.`,
    },
    {
      src: "/images/review8.png",
      txt: `도어락이 고장나보긴 생전 처음이라<br/>
참 당황했는데 키플레이어에서<br/>
깔끔하게 잘 해결해줬어요`,
    },
    {
      src: "/images/review9.png",
      txt: `외국인 친구집에 도어락이 고장나<br/>
유선상으로 도움을 요청드렸는데<br/>
친절하게 잘 해주셨어요`,
    },
    {
      src: "/images/review10.png",
      txt: `도어락이 불도 안켜지고 정말<br/>
환장할 노릇이었는데 키플레이어 덕에<br/>
다행히 하루만에 잘 해결되었답니다.`,
    },
  ];

  const [count, setCount] = useState(5);

  useEffect(() => {
    if (window.innerWidth > 800) {
      setCount(5);
    } else {
      setCount(1);
    }

    window.addEventListener("resize", () => {
      if (window.innerWidth > 800) {
        setCount(5);
      } else {
        setCount(1);
      }
    });

    return () => {
      window.removeEventListener("resize", () => {
        if (window.innerWidth > 800) {
          setCount(5);
        } else {
          setCount(1);
        }
      });
    };
  }, []);

  useEffect(() => {});
  return (
    <div id="review" className="relative w-full h-full py-14 lg:py-28 xl:pb-36">
      <div
        id="title"
        className="relative w-full h-fit text-center mb-10 xl:mb-20"
      >
        <h2 className="flex items-end justify-center gap-0.5 font-medium text-black">
          <img
            alt="키플레이어 도어락 로고"
            className="!relative w-auto h-full flex-wrap lg:flex-nowrap max-h-8 lg:max-h-12 py-1 object-contain cursor-pointer"
            src="/images/logo.png"
            width={531}
            height={65}
          />
          <span className="-mb-1.5 lg:-mb-2">고객 REVIEW</span>
        </h2>
        <p className="my-3 lg:my-5 lg:text-lg">
          {" "}
          -&nbsp;REAL&nbsp;REVIEW&nbsp;-
        </p>
        <p className=" mt-5 text-xl manru font-black ">·&nbsp;·&nbsp;·</p>
      </div>
      <Swiper
        spaceBetween={30}
        // centeredSlides={true}
        loop={true}
        slidesPerView={count}
        autoplay={{
          delay: 3500,
          disableOnInteraction: false,
        }}
        modules={[Autoplay]}
        className=" relative w-full h-full mx-auto grid"
      >
        {reviewList.map((v, i) => (
          <SwiperSlide
            key={i}
            className=" relative w-full h-full min-w-72 px-5 lg:px-0 "
          >
            <div className=" relative w-full h-full py-5">
              <div className="relative w-full h-10 max-w-44 mx-auto mb-2 animate-bounce ">
                <img
                  src="/images/iconStar.png"
                  alt="고객 만족도 별점 5점"
                  className=" relative w-full h-fit object-contain"
                />
              </div>
              <div className="relative w-full h-[calc(100%-40px)] min-h-72 p-3 rounded-2xl bg-white border shadow-md">
                <img
                  className="relative w-full h-auto object-cover object-center rounded-3xl"
                  src={v.src}
                  alt={`키플레이어 도어락 고객 후기 ${i + 1}`}
                />
                <div className=" relative w-full h-fit text-center pt-5">
                  <p
                    className="text-black"
                    dangerouslySetInnerHTML={{ __html: v.txt }}
                  ></p>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Review;
